import { takeLatest, put, select, all, call } from 'redux-saga/effects';
import { message } from 'antd';
import { updateDashboard } from '@api/dashboards';
import { autoRequest } from '@api/createRequestStore';
import {
  changeSaveDashboardPromptVisibility,
  toggleUpdatePopupVisible,
} from '@store/dashboards/ui/actions';
import { getList } from '@store/dashboards/list/actions';
import { updatedSavedDashboard } from '@store/tempDashboard/actions';

import * as actions from './actions';
import * as tabsActions from '../tabs/actions';
import * as types from './types';
import udpateSelector from './selectors';

function* afterRequest() {
  const state = yield select(udpateSelector);
  if (!state) {
    return;
  }

  const { payload } = state;
  const tab = { ...payload.payload, id: payload.id };
  // message.success(`Dashboard "${tab.name}" has been saved successfully`);

  yield all([
    put(tabsActions.triggerUpdateTab(tab, tab.id, true)),
    put(changeSaveDashboardPromptVisibility(false)),
    put(getList()),
  ]);
}

function* afterUpdated() {
  yield all([put(getList())]);
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* updating({ payload, id, createThenMakeDefault, makeDefaultFn }) {
  yield put(actions.fetching());
  try {
    const res = yield autoRequest(updateDashboard, types.SCOPE, { payload, id }, afterRequest);
    if (createThenMakeDefault) {
      makeDefaultFn(res);
    }
    if (!createThenMakeDefault) {
      const tab = { ...payload, id };
      message.success(`Dashboard "${tab.name}" has been saved successfully`);
    }
  } catch (error) {
    message.error(error.message);
  }
}

function* updateById({ id, dashboardName, dashboard, showNotification }) {
  const payload = {
    name: dashboardName,
    config: dashboard,
    isSaved: true,
  };
  try {
    yield autoRequest(updateDashboard, types.SCOPE, { payload, id }, afterUpdated);
    yield put(toggleUpdatePopupVisible(false, id));
    yield put(updatedSavedDashboard(id, dashboardName));

    if (showNotification) {
      yield call(message.success, 'Successfully updated!');
    }
  } catch (error) {
    message.error(error.message);
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchUpdating() {
  yield takeLatest([types.UPDATE_DASHBOARD], updating);
}

function* watchUpdateById() {
  yield takeLatest([types.UPDATE_DASHBOARD_BY_ID], updateById);
}

export default [watchInitRequest, watchUpdating, watchUpdateById];
